/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useState } from "react";
import { useDeleteCloudAccountMutation } from "~/generated/graphql";
import { showError } from "~/services/toast";
import { removeFromApolloCache } from "~/tools";

type Props = {
  onSuccess: () => void;
};

export function useDeleteCloudAccount({ onSuccess }: Props) {
  const [id, setId] = useState("");
  const [deleteAccountMutation, { client, ...rest }] =
    useDeleteCloudAccountMutation({
      onCompleted: (data) => {
        if (data.removeCloudAccount) {
          onSuccess();
          removeFromApolloCache(
            client.cache,
            `CloudAccount:${id}`,
            "cloudAccounts"
          );
        } else {
          showError();
        }
      },
    });

  async function deleteCloudAccount(cloudId: string) {
    setId(cloudId);
    await deleteAccountMutation({
      variables: {
        removeCloudAccountId: cloudId,
      },
    });
  }

  return [deleteCloudAccount, { client, ...rest }] as const;
}
